import {
    LitElement,
    html,
    css,
    utils,
    styles,
  } from '@hh/global.js'

  class HHSidebarDropdown extends LitElement {
    constructor() {
      super()
    }

    connectedCallback() {
      super.connectedCallback()
    }

    disconnectedCallback() {
      super.disconnectedCallback()
    }

    handleChange (e) {
      window.location.href = e.target.value
    }

    render() {
      return html`
          <slot
            @change="${this.handleChange}"
          ></slot>
      `
    }

    static styles = [
      styles.visuallyHidden,
      css`
      `,
    ]
  }

  customElements.define('hh-sidebar-dropdown', HHSidebarDropdown)
